var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mantenedor-tipo-ubicacion" }, [
    _c(
      "div",
      { staticClass: "flex sm12 m12" },
      [
        _c(
          "FormFieldsContainer",
          [
            _c(
              "v-flex",
              {
                attrs: {
                  sm12: "",
                  md12: "",
                  layout: "",
                  wrap: "",
                  "justify-space-between": "",
                  "mb-4": ""
                }
              },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm6: "", md6: "" } },
                  [
                    _c("v-text-field", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { label: "Buscar...", "append-icon": "search" },
                      on: { input: _vm.handleSearch },
                      model: {
                        value: _vm.filtrobusquedagrilla,
                        callback: function($$v) {
                          _vm.filtrobusquedagrilla = $$v
                        },
                        expression: "filtrobusquedagrilla"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  {
                    attrs: {
                      xs12: "",
                      sm6: "",
                      md6: "",
                      "layout-flex-tipo-ubicacion": ""
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", small: "", color: "primary" },
                        on: { click: _vm.exportarExcel }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v("  \n            "),
                        _c("span", { staticClass: "importExportBtnTexto" }, [
                          _vm._v("Exportar"),
                          _c("br"),
                          _vm._v("CSV")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-guardar",
                        on: { click: _vm.handleAdd }
                      },
                      [
                        _c("v-icon", { staticClass: "mr-2" }, [
                          _vm._v("add_circle_outline")
                        ]),
                        _vm._v("\n            Crear\n          ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("MantenedorGridSinCodigo", {
          attrs: {
            "grid-options": _vm.gridOptions,
            funcionalidadId: _vm.funcionalidad
          }
        }),
        _c("app-confirmacion", {
          attrs: {
            show: _vm.dialogEliminar,
            titulo: "Eliminar Tipo de Ubicación",
            mensaje:
              "¿Estás seguro de que deseas eliminar a " +
              _vm.data.tipoubicaname +
              "?",
            textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
            textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
          },
          on: {
            modalConfirmationEmit: function($event) {
              return _vm.handleDeleteTipoUbicacion($event)
            }
          }
        }),
        _vm.showModal
          ? _c("ModalViewTipoUbicacion", {
              attrs: { data: _vm.data, anulado: _vm.anulado },
              on: { cerrar: _vm.handleClosedModal }
            })
          : _vm._e(),
        _vm.verHistorico
          ? _c("ModalVerHistorico", {
              attrs: {
                tipoubicaname: _vm.tipoubicaname,
                tipoubicaid: _vm.tipoubicaid
              },
              on: { modalAsociacionEmit: _vm.handleClosedModal }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }